import React, { useEffect, useRef } from 'react';
import { useAudioContext } from '../../context/AudioContext';

export default function GlobalAudioPlayer() {
  const { isPlaying, isPaused } = useAudioContext();
  const audioRef = useRef(null);

  useEffect(() => {
    // Si se está leyendo el texto, reproducimos el audio en silencio en loop
    // Esto mantiene vivo el proceso en iOS/Android y activa la MediaSession
    if (audioRef.current) {
      if (isPlaying && !isPaused) {
        audioRef.current.play().catch(e => console.log('Silent audio play blocked by browser', e));
      } else {
        audioRef.current.pause();
      }
    }
  }, [isPlaying, isPaused]);

  return (
    <audio
      ref={audioRef}
      src="/silence.wav"
      loop
      playsInline
      style={{ display: 'none' }}
    />
  );
}
